import { render, staticRenderFns } from "./TipYesMatch.vue?vue&type=template&id=1c46369a&scoped=true"
import script from "./TipYesMatch.vue?vue&type=script&lang=js"
export * from "./TipYesMatch.vue?vue&type=script&lang=js"
import style0 from "./TipYesMatch.vue?vue&type=style&index=0&id=1c46369a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46369a",
  null
  
)

export default component.exports